import * as React from "react";
import type { JSX } from "react";

import { nullToEmpty } from "../../utils/string";

import * as theme from "./Arrow.css";

interface ArrowProps {
    className?: string;
}

class Arrow extends React.PureComponent<ArrowProps> {
    render = (): JSX.Element => {
        const { className } = this.props;
        return <span className={`${theme.arrow} ${nullToEmpty(className)}`} />;
    };
}

export { Arrow };
